// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"cc2bb738","223":"b1b1a4e7","239":"c1564a28","739":"edca6786","769":"ee41d4b8","958":"893ea94d","968":"47044ddd","974":"c7c1e748"}[chunkId] + ".chunk.js";
};